import { render, staticRenderFns } from "./HeadExtraction.vue?vue&type=template&id=083bcfb0&scoped=true"
import script from "./HeadExtraction.vue?vue&type=script&lang=js"
export * from "./HeadExtraction.vue?vue&type=script&lang=js"
import style0 from "./HeadExtraction.vue?vue&type=style&index=0&id=083bcfb0&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "083bcfb0",
  null
  
)

export default component.exports